import { LandingHeader } from "../components/landing/LandingHeader";
import { LandingHero } from "../components/landing/LandingHero";
import { FeaturesBento } from "../components/landing/FeaturesBento";
import { CollabShowcase } from "../components/landing/CollabShowcase";
import { DrawingsShowcase } from "../components/landing/DrawingsShowcase";
import { HowItWorks } from "../components/landing/HowItWorks";
import { PricingSection } from "../components/landing/PricingSection";
import { FinalCta } from "../components/landing/FinalCta";
import { LandingFooter } from "../components/landing/LandingFooter";
import { PwaInstallBanner } from "../components/ui/PwaInstallBanner";

interface LandingPageProps {
  onLoginClick: () => void;
  onNavigate: (path: string) => void;
  /** Usuário já logado vendo a landing (a "/" continua acessível na web). */
  isAuthenticated?: boolean;
}

/**
 * Landing page pública do Taskletto.
 *
 * A landing tem identidade visual própria e fixa (cream/ink/laranja) e NÃO
 * responde ao dark mode do app — por isso usa apenas os tokens `cream`,
 * `ink`, `primary-*`, `zinc-*` e `white` (nunca `neutral-*`, que é
 * invertido pela classe `.dark` no index.css).
 */
export const LandingPage: React.FC<LandingPageProps> = ({ onLoginClick, onNavigate, isAuthenticated }) => {
  return (
    <div className="min-h-screen bg-cream font-sans">
      <LandingHeader onLoginClick={onLoginClick} isAuthenticated={isAuthenticated} />
      <LandingHero onLoginClick={onLoginClick} />
      <FeaturesBento />
      <CollabShowcase />
      <DrawingsShowcase />
      <HowItWorks />
      <PricingSection onLoginClick={onLoginClick} />
      <FinalCta onLoginClick={onLoginClick} />
      <LandingFooter onNavigate={onNavigate} />
      <PwaInstallBanner variant="landing" />
    </div>
  );
};
